module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-70"
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-2": "",
      "pa-5": ""
    }
  }, [_c('V-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "align-center": "",
      "mb-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "lg12": "",
      "sm12": "",
      "xs12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "font-24"
  }, [_vm._v("Decades of Financial Expertise")]), _vm._v(" "), _c('div', {
    staticClass: "font-14 mt-2"
  }, [_vm._v("Real solutions to today's real problems")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-5": "",
      "mb-5": ""
    }
  }, [_c('v-container', {
    attrs: {
      "pa-0": "",
      "grid-list-xl": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2",
    attrs: {
      "hover": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text"
  }, [_c('a', {
    staticClass: "pointer",
    attrs: {
      "href": "https://iobots.pro",
      "target": "_blank"
    }
  }, [_vm._v("ioBots")])]), _vm._v(" "), _c('v-card-text', [_vm._v("ioBots are professional-grade cryptocurrency trading systems with portfolio risk management and trading strategies aimed at the post-Millennial and Generation Z traders:")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        Commission- and fee-free; a mobile- and anywhere-platform. \n                                    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                                        The most comprehensive trading system on the market that helps its users to stay in the game for a long time.\n                                    ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2",
    attrs: {
      "hover": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text"
  }, [_c('a', {
    staticClass: "pointer",
    attrs: {
      "href": "https://beta.poet.best",
      "target": "_blank"
    }
  }, [_vm._v("PoET")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Proof of Enquiries & Trades (PoET) is a DLT solution that records every order enquiry ever sent – whether filled or not – and every trade ever executed on a distributed ledger. It makes regulatory compliance and enforcement easy and cost-effective.")]), _vm._v(" "), _c('v-card-text', [_vm._v("Trader Credit Score (TCS) is a product that helps licensed firms and their traders streamline their compliance requirements.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2",
    attrs: {
      "hover": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-24 primary--text"
  }, [_c('a', {
    staticClass: "pointer",
    attrs: {
      "href": _vm.domainName
    }
  }, [_vm._v("SiP")])]), _vm._v(" "), _c('v-card-text', [_vm._v("The crowd wisdom helps identify financial market manipulations and fake news;")]), _vm._v(" "), _c('v-card-text', [_vm._v("A social network rewards good contents.")]), _vm._v(" "), _c('v-card-text', [_vm._v("Helps build a loyal and active community.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-lg-right",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": "",
      "mt-5": ""
    }
  }, [_c('div', [_c('a', {
    attrs: {
      "href": _vm.domainName
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey",
      "size": "20"
    }
  }, [_vm._v("arrow_back")])], 1)])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ce230f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about/About.vue
// module id = 454
// module chunks = 0